import { useEffect, useState, createRef } from "react";
import { disableMapEvents } from "../utils/mapFunctions";
import MapConfig from "../utils/map-config.json";
import { getDatasetsJson } from "../utils/DatasetsJson";
import Placeholder from "../img/image_placeholder.png";

const DetailControl = (props) => {
  const DatasetsJson = getDatasetsJson();
  const panelRef = createRef();
  const [id, setId] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    disableMapEvents(panelRef);
  }, [panelRef]);

  useEffect(() => {
    const getCatalogueId = (layerId) => {
      for (const provider of DatasetsJson) {
        for (const dataset of provider.datasets || []) {
          const found = dataset.layers?.find(layer => layer.num_layer === layerId);
          if (found) {
            return provider.id;
          }
        }
      }
      return null;
    }
    let catalogueId = DatasetsJson.some(a => a.id === props.id) ? props.id : getCatalogueId(props.id);
    let info = DatasetsJson.find(a => a.id === catalogueId);
    setId(catalogueId);
    setData(info);
  }, [DatasetsJson, props.id]);

  const findLayers = () => {
    let layers = data.datasets?.reduce((sum, dataset) => sum + dataset.layers.length, 0);
    return layers;
  }

  const formatDate = (date) => {
    date = new Date(date);
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();
    date = (d <= 9 ? "0" + d : d) + "/" + (m <= 9 ? "0" + m : m) + "/" + y;
    return date;
  };

  const getDates = () => {
    let date;
    let dateStart = data.start_datetime || findDates()[0];
    let dateEnd = data.end_datetime || findDates()[1];
    if (!dateStart && !dateEnd) {
      date = "Date not available"
    }
    else {
      date = (dateStart ? formatDate(dateStart) : "-") + " to " + (dateEnd ? formatDate(dateEnd) : "-");
    }
    return date;
  }

  const findDates = () => {
    let minStart = null;
    let maxEnd = null;
    
    data.datasets.forEach(dataset => {
      const startDate = new Date(dataset.start_datetime);
      const endDate = new Date(dataset.end_datetime);

      if (!minStart || startDate < minStart) {
        minStart = startDate;
      }
      if (!maxEnd || endDate > maxEnd) {
        maxEnd = endDate;
      }
    });

    return [minStart, maxEnd];
  };

  const getExtent = () => {
    let extent = data.extent || findExtent();
    
    return (
      <>
      <div>Latitude extent: {extent.length > 0 ? Math.round(extent[0] / 10) * 10 + "° to " + Math.round(extent[2] / 10) * 10 + "°" : "Not available"}</div>
      <div>Longitude extent: {extent.length > 0 ? Math.round(extent[1] / 10) * 10 + "° to " + Math.round(extent[3] / 10) * 10 + "°" : "Not available"}</div>
      </>
    )
  };

  const findExtent = () => {
    let minLat = null;
    let maxLat = null;
    let minLon = null;
    let maxLon = null;

    data.datasets.forEach(dataset => {
      const extentArray = dataset.extent.split(",");
      
      if (extentArray.length === 4) {
        const [minLongitude, minLatitude, maxLongitude, maxLatitude] = extentArray.map(val => parseFloat(val));

        if (minLon === null || minLongitude < minLon) minLon = minLongitude;
        if (maxLon === null || maxLongitude > maxLon) maxLon = maxLongitude;
        if (minLat === null || minLatitude < minLat) minLat = minLatitude;
        if (maxLat === null || maxLatitude > maxLat) maxLat = maxLatitude;
      }
    });
    
    return [minLat, minLon, maxLat, maxLon];
  };

  const convertLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a className="ccl-link" key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const formatText = (text) => {
    return (
      <div>
        {text?.split("\n").map((paragraph, index) => (
          <p key={index}>
            {convertLinks(paragraph)}
          </p>
        ))}
      </div>
    );
  };

  const handleImageError = (e) => {
    e.target.src = Placeholder;
    e.target.onerror = null;
  };

  return (
    <div className="widget-panel-overlay" ref={panelRef}>
      <div className="detail-container">
        {
          Object.keys(data).length !== 0 &&
          <>
            <div className="widget-title">
              {data.title}
              <button className="icon-button widget-close" onClick={() => {props.setShowDetail(null)}} aria-label="Close">
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="detail-item">
              <div className="detail-image">
                <img src={data.thumbnail || Placeholder} alt="Dataset thumbnail" style={{objectFit: data.title.includes("UNESCO") ? "contain" : ""}} onError={handleImageError}/>
              </div>
              <div className="detail-icon detail-layers">
                <i className="fa-solid fa-layer-group"></i>
                <span>{findLayers()}</span>
              </div>
              <div className="catalogue-buttons">
                <button className="ccl-button ccl-button--default" disabled={findLayers(data.datasets) === 0 && !data.metadata_url} onClick={() => {findLayers(data.datasets) === 0 ? window.open(data.metadata_url, '_blank') : props.setShowDatasets(id)}} aria-label={findLayers(data.datasets) === 0 ? "Use dataset" : "Add layers"}>
                  {findLayers(data.datasets) === 0 ? "Use dataset" : "Add layers"}
                </button>
              </div>
              {data.access_email &&
                <div className="detail-message">
                  {MapConfig.Messages[data.service]} <a className="ccl-link" href={`mailto:${data.access_email}`}>{data.access_email}</a>
                </div>
              }
              <div className="detail-description">{formatText(data.description)}</div>
              <div className="detail-icon  detail-date">
                <i className="fa-regular fa-calendar"></i>
                <span>{getDates()}</span>
              </div>
              <div className="detail-icon detail-coords">
                <i className="fa-solid fa-expand"></i>
                <div>{getExtent()}</div>
              </div>
              <div className="detail-icon detail-metadata">
                <a className="ccl-link" href={data.metadata_url} target="_blank" rel="noopener noreferrer">
                  <i className="fa-regular fa-file-lines"></i>
                  Metadata
                </a>
              </div>
              {(data.id || data.service || data.published || data.area || data.time || data.tags) && (
                <>
                  <hr />
                  <div className="detail-classification">
                    <div className="detail-subtitle">Classification</div>
                    {
                      [
                        // { label: "Dataset ID", value: data.id },
                        { label: "Published", value: data.published },
                        { label: "Data source", value: MapConfig.Filters.find(a => a.filter === "service")?.labels.find(a => a.name === data.service)?.label ?? data.service },
                        { label: "Area", value: data.area },
                        { label: "Time", value: data.time },
                        { label: "Tags", value: data.tags }
                      ]
                      .filter(item => item.value)
                      .map((item, index) => (
                        <div key={index}>
                          <span>{item.label}:</span> {item.value}
                        </div>
                      ))
                    }
                  </div>
                </>
              )}
              {(data.distributor || data.custodian || data.contact || data.owner) && (
                <>
                  <hr />
                  <div className="detail-contacts">
                    <div className="detail-subtitle">Contacts</div>
                    {
                      [
                        { label: "Distributor", value: data.distributor },
                        { label: "Custodian", value: data.custodian },
                        { label: "Point of contact", value: data.contact },
                        { label: "Owner", value: data.owner }
                      ]
                      .filter(item => item.value)
                      .map((item, index) => (
                        <div key={index}>
                          <span>{item.label}:</span> {item.value}
                        </div>
                      ))
                    }
                  </div>
                </>
              )}
            </div>
          </>
        }
      </div>
    </div>
  );
}

export default DetailControl;
